import { useNavigate } from "react-router-dom";
import imgWhiteLogo1 from "../assets/2ccda97ecaa4b401fe79d7f0575e654788a45c27.png";

type Note = {
  title: string;
  description: string;
};

const notes: Note[] = [
  {
    title: "No more emails",
    description: "We've updated your preferences and will stop sending campaign news, surveys, and invitations.",
  },
  {
    title: "Your choice matters",
    description: "We'd rather keep you in the loop, but respect your decision and won't reach out again unless you opt back in.",
  },
  {
    title: "Change your mind anytime",
    description: "You can rejoin the list by signing up on our homepage or at any Project Ontario event.",
  },
];

export default function OptOutConfirmationPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-[#00499d] text-white">
      <header className="w-full border-b border-white/15 bg-[#00499d]/85 backdrop-blur">
        <div className="mx-auto flex max-w-[1100px] items-center justify-between px-4 py-4">
          <button onClick={() => navigate("/")} className="flex items-center gap-2 text-white hover:opacity-80">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Home
          </button>
          <div className="flex items-center gap-3">
            <img src={imgWhiteLogo1} alt="Project Ontario" className="h-8 w-8" />
            <div className="font-black leading-5 tracking-tight">
              <div>PROJECT</div>
              <div>ONTARIO</div>
            </div>
          </div>
          <div className="w-16" aria-hidden />
        </div>
      </header>

      <main className="flex items-center justify-center px-4 py-12 md:py-16">
        <div className="relative w-full max-w-[900px] overflow-hidden rounded-3xl border border-white/15 bg-white/10 p-6 shadow-2xl md:p-10">
          <div
            className="absolute inset-0 -z-10 opacity-60"
            style={{
              background:
                "radial-gradient(90% 90% at 20% 30%, rgba(255,255,255,0.12), transparent 40%), radial-gradient(110% 110% at 80% 0%, rgba(255,255,255,0.06), transparent 55%)",
            }}
          />
          <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="flex flex-col items-center gap-4 text-center md:flex-row md:items-start md:text-left">
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#00499d]">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </div>
              <div>
                <p className="text-sm uppercase tracking-[0.2em] text-white/70">Preference saved</p>
                <h1 className="text-3xl font-black md:text-4xl">Thanks for letting us know</h1>
                <p className="mt-3 max-w-2xl text-base text-white/80 md:text-lg">
                  We respect your decision and won't contact you further. You can still visit the site anytime to see what
                  Project Ontario is working on.
                </p>
              </div>
            </div>
            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 text-center text-sm text-white/80 md:text-left">
              Effective immediately: no more emails from Project Ontario.
            </div>
          </div>

          <div className="mt-8 grid gap-4 md:grid-cols-3">
            {notes.map((item) => (
              <div key={item.title} className="rounded-2xl border border-white/10 bg-[#ffffff0d] p-5">
                <h2 className="text-lg font-semibold text-white">{item.title}</h2>
                <p className="mt-2 text-sm text-white/75">{item.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <button
              onClick={() => navigate("/")}
              className="inline-flex w-full items-center justify-center rounded-full bg-white px-5 py-3 text-sm font-semibold text-[#00499d] transition hover:scale-[1.02] hover:shadow-lg sm:w-auto"
            >
              Return to the homepage
            </button>
            <a
              href="/#signup"
              className="inline-flex w-full items-center justify-center rounded-full border border-white/20 bg-white/10 px-5 py-3 text-sm font-semibold text-white transition hover:border-white/50 hover:bg-white/15 sm:w-auto"
            >
              Re-subscribe anytime
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
